module.exports = __webpack_public_path__ + "img/no-reports.8cadf622.svg";